import { GTMDataLayer } from "../adapters/types";

export const BUTTON_SIZES = {
  SMALL: 'small',
  STANDARD: 'standard'
};

export const HEADING_TYPES = {
  DISPLAY_1: 'display-1',
  DISPLAY_2: 'display-2',
  DISPLAY_3: 'display-3',
  HEADING_1: 'heading-1',
  HEADING_2: 'heading-2',
  SUBTITLE_1: 'subtitle-1',
  SUBTITLE_2: 'subtitle-2',
  SUBTITLE_3: 'subtitle-3'
};

export const gtmId = 'GTM-P8QBWVM';

export const BUTTON_VARIANTS = {
  ICON: 'icon',
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  TEXT: 'text'
};

export const KEYBOARD_EVENT = {
  ENTER: 'Enter'
};

export const REACT_QUERY_OPTIONS = {
  RETRY: 0,
  REFETCH_ON_WINDOW_FOCUS: false,
  REFETCH_ON_MOUNT: false,
  REFETCH_ON_RECONNECT: true,
  STALE_TIME: 10000
};

export const QUERY_TIME = {
  FIVE_MINUTES: 1000 * 60 * 5,
  TEN_MINUTES: 1000 * 60 * 10,
  THREE_MINUTES: 1000 * 60 * 3,
  ONE_HOUR: 1000 * 60 * 60,
  ONE_DAY: 1000 * 60 * 60 * 24
};

export const PRINTER_TIMEOUT = 3000;
export const API_SEARCH_DELAY = 1000;

export const DASHBOARD_SEARCH_DELAY = 800;

export const TOAST_VARIANTS = {
  NEGATIVE: 'negative',
  NEUTRAL: 'neutral',
  POSITIVE: 'positive',
  WARNING: 'warning',
  INFORMATION: 'information'
};

export const PO_STATUS = {
  INCOMPLETED: 'INC',
  APPROVED: 'APP',
  STARTED: 'STARTED',
  INVOICED: 'INV',
  VOID: 'VOID',
  READY: 'READY'
};

export const PO_SUBSTATUS = {
  STARTED: 'STARTED',
  READY: 'READY',
  INVOICED: 'INVOICED',
  VOID: 'VOID',
  CLOSED: 'CLOSED',
  DENIED: 'DENIED',
  APPROVAL_REQUIRED: 'APPROVAL_REQUIRED',
  ORDERED: 'ORDERED',
  RECEIVING: 'RECEIVING',
  RECEIVED: 'RECEIVED',
  PRE_INVOICING: 'PRE_INVOICING',
  PRE_INVOICED: 'PRE_INVOICED',
  SUBMITTED: 'SUBMITTED'
};

export const TOAST_VISIBILITY_DURATIONS = {
  EIGHT_SECONDS: 8000,
  INFINITE: 0,
  SEVEN_SECONDS: 7000,
  SIX_SECONDS: 6000
};

export const DateFormat = {
  mmddyyyy: 'MM/DD/YYYY',
  [`yyyy-mm-dd`]: 'YYYY-MM-DD'
};

export const TextCellEditorType = {
  Currency: 'currency',
  DatePicker: 'datePicker',
  SingleSelector: 'singleSelector'
};

export const InitialRequester = [{ id: 1, name: '', simpleId: null }];

export enum SortColumnName {
  PO_NBR = 'PO_NBR',
  ORDER_NO = 'ORDER_NO',
  ORDER_DATE = 'ORDER_DATE',
  UPDATED_DATE = 'UPDATED_DATE',
  VENDOR_NO = 'VENDOR_NO',
  VENDOR_NAME = 'VENDOR_NAME',
  AMOUNT = 'AMOUNT'
}

export enum SortOrder {
  ASC = 'ASC',
  DESC = 'DESC'
}

export enum FloatDirection {
  LEFT = 'left',
  RIGHT = 'right'
}

export enum PhoneNumberType {
  WORK_FAX = 'WORK_FAX'
}

export const COLUMN_TITLES = [
  { text: 'Transmission Date and Type', bold: true },
  { text: 'Purchase Order Numbers', bold: true },
  { text: 'Customer PO', bold: true },
  { text: 'Transmission', bold: true },
  { text: 'Processed', bold: true },
  { text: 'Fulfilled', bold: true }  
];

 
 

 
export const FILETYPE = {
  XLS: 'XLS',
  CSV: 'CSV',
  PDF: 'PDF'
};

export const ACTIONSTYPE = {
  EXPORT: 'Export',
  ARCHIVE: 'Archive'
};

export const COMPLETED = 'COMPLETED';

export const REFETCHINTERVAL = 5000;

export const AcceptableInputs = [
  'Backspace',
  '-',
  'ArrowRight',
  'ArrowLeft',
  'Tab',
  'Delete',
  'Enter',
  'Shift'
];

export const KEYINPUTS = {
  ArrowDown: 'ArrowDown'
};


export const defaultGtmDataLayer: GTMDataLayer = {
  d_user_id: '',
  d_company_id: '',
  d_company_name: '',
  d_company_access: '',
  d_enterprise_id: '',
  d_department_id: '',
  d_user_roles: []
};

 

export const FOCUS_TIMEOUT = {
  BACK_BUTTON: 500,
  SIDE_PANEL: 100,
  PAGE_HEADER: 50,
  PO_ITEMLINE: 10
};

export const CHEETAH_ROUTE = {
  MFE_PO_ACCESS_DENIED: '/access-denied',
  MFE_PO_ERROR: '/error'
};

export const permissions = {
  ACCESS_PO: 'ACCESS_PO'
};

export const MANUAL_CLOSE_ACCOUNTING_PURCHASE_ORDER =
  'MANUAL_CLOSE_ACCOUNTING_PURCHASE_ORDER';
export const VOID_ACCOUNTING_PURCHASE_ORDER = 'VOID_ACCOUNTING_PURCHASE_ORDER';
export const VOID_DMS_PURCHASE_ORDER = 'VOID_DMS_PURCHASE_ORDER';

export const VOID_PERMISSONS = {
  MISC: 'VOID_ACCOUNTING_PURCHASE_ORDER',
  PARTS: 'VOID_PARTS_PURCHASE_ORDER',
  SERVICE: 'VOID_SERVICE_PURCHASE_ORDER',
  VEHICLE: 'VOID_VEHICLE_PURCHASE_ORDER'
};

export const MANUAL_CLOSE_PERMISSIONS = {
  MISC: 'MANUAL_CLOSE_ACCOUNTING_PURCHASE_ORDER',
  PARTS: 'MANUAL_CLOSE_PARTS_PURCHASE_ORDER',
  SERVICE: 'MANUAL_CLOSE_SERVICE_PURCHASE_ORDER',
  VEHICLE: 'MANUAL_CLOSE_VEHICLE_PURCHASE_ORDER'
};

export const DELETE_PERMISSIONS = {
  MISC: 'DELETE_ACCOUNTING_PURCHASE_ORDER',
  PARTS: 'DELETE_PARTS_PURCHASE_ORDER',
  SERVICE: 'DELETE_SERVICE_PURCHASE_ORDER',
  VEHICLE: 'DELETE_VEHICLE_PURCHASE_ORDER'
};

export const PURCHASE_ORDER_PERMISSIONS = Object.values(permissions);

export const DEFAULT_GROUP_NAME = 'PLF-A_default';

 
 

export const LOCALE = {
  ENGLISH: 'en_US',
  FRENCH: 'fr_CA'
};

export const LANGUAGE = {
  ENGLISH: 'en',
  FRENCH: 'fr'
};

 

export const batchCloseStatus = 'FAILED';

export const isBatchClosePOAmountFlag = true;

 
 
 

 
